import type { CommonStore } from './interfaces'
import type { Notification } from '@brighterly/lib-core-types/ui/notifications/interfaces'

export const getters = {
  isLoading: (state: CommonStore): CommonStore['loading'] => state.loading,
  getNotification: (state: CommonStore): Notification => state.notification,
  getInformationBanner: (state: CommonStore): CommonStore['informationBanner'] => state.informationBanner,
  isInformationBannerDemo: (state: CommonStore): boolean => state.informationBanner.information_banner_is_demo,
  isInformationBannerPaid: (state: CommonStore): boolean => state.informationBanner.information_banner_is_paid,
  getInformationBannerText: (state: CommonStore): string => state.informationBanner.information_banner_text,
  getInformationBannerTitle: (state: CommonStore): string => state.informationBanner.information_banner_title,
  isNoScroll: (state: CommonStore): boolean => state.noScroll,
  isModalShowed: (state: CommonStore): boolean => state.modalShowed,
}
